import { defineMessages } from 'react-intl-next';

export const messages: {
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'search-branch-result.label',
		defaultMessage: 'Branch',
		description: 'Search branch label',
	},
});
